import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import Typography from '@mui/material/Typography';

/*position alternate left o right*/

const TimelineEdu = () => {
  return (
    <Timeline position="right">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          2020 - actualidad
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h5" component="span">
            Cursos
          </Typography>
          <Typography><b>OpenWebinars, Platzi, Benowu, Crehana...</b></Typography>
          <Typography>Cursos de informática, desarrollo web y multiplataforma. Puedes ver más <a href="https://arturocode.github.io/cursos/">aquí</a>.</Typography>
        </TimelineContent>
      </TimelineItem>
      
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          2020 - 2022
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h5" component="span">
            DAW
          </Typography>
          <Typography><b>IES Juan de la Cierva</b></Typography>
          <Typography>Desarrollo, diseño, instalación, despliegue y mantenimiento de aplicaciones web. Java, JavaScript, PHP, Symfony, SQL, Bootstrap y más.</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          2017 - 2019
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
        <Typography variant="h5" component="span">
            SMR
          </Typography>
          <Typography><b>IES Juan de la Cierva</b></Typography>
          <Typography>Instalación y configuración de SO, programas, redes locales y servicios en red. Montaje y mantenimiento de equipos y seguridad informática.
</Typography>
        </TimelineContent>
      </TimelineItem>

    </Timeline>
  );
}

export default TimelineEdu